<template>
  <div class="columns is-multiline is-mobile">
    <div class="column is-half-desktop is-full-mobile">
      <window title="HTML Editor using Vue.js and Quilljs. (base64 encoding for images) <a href='https://davidroyer.github.io/vue2-editor/#/' target='_blank'>(more info)" height="100%">
        <vue-editor id="editor1" v-model="contentBase64"></vue-editor>
      </window>
    </div>
    <div class="column is-half-desktop is-full-mobile">
      <window title="Editor with image uploading <a href='https://davidroyer.github.io/vue2-editor/#/?id=example-custom-image-handler' target='_blank'>(more info)</a>" height="100%">
        <vue-editor id="editor2" v-model="contentImageUpload"
        useCustomImageHandler @imageAdded="handleImageAdded"></vue-editor>
      </window>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
// import axios from 'axios'

export default {
  name: 'TextEditor',
  components: {
    VueEditor,
  },
  data() {
    return {
      contentBase64: '<p>Some demo content</p>',
      contentImageUpload: '<p>Another demo content</p>',
    };
  },
  methods: {
    handleImageAdded(/* file, Editor, cursorLocation, resetUploader */) {
      // console.log('Uploading image...')
      // var formData = new FormData()
      // formData.append('image', file)

      // axios({
      //   url: 'https://fakeapi.yoursite.com/images',
      //   method: 'POST',
      //   data: formData
      // })
      //   .then((result) => {
      //     let url = result.data.url // Get url from response
      //     Editor.insertEmbed(cursorLocation, 'image', url)
      //     resetUploader()
      //   })
      //   .catch((err) => {
      //     console.log(err)
      //   })
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  background: white;
  margin: 20px;
}
</style>
